import { render } from "./EventListView.vue?vue&type=template&id=94be9c1a"
import script from "./EventListView.vue?vue&type=script&lang=js"
export * from "./EventListView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__